import type {
  Department,
  DepartmentDto
} from '../types';

export function departmentFromDto(dto: DepartmentDto): Department{
  return {
    id: dto.id,
    name: dto.dept_name,
    internal: dto.dept_internal,
  };
}
